// 工具-服务
export default {
  /**
   * 一位数前边补0
   * 
   * @params value 要补齐的文字
   */
  formatNumber(value = '') {
    value = value.toString();
    return value[1] ? value : '0' + value;
  },

  /**
   * 判断空
   * 
   * @params value 要判断的字符串
   */
  isEmpty(value) {
    if (value == '') return true;
    if (value == undefined) return true;
    if (value == null) return true;
    return false;
  },

  /**
   * 判断手机号
   * 
   * @params phone 要判断的字符串
   */
  isPhone(phone) {
    return /^[1][3456789]\d{9}$/.test(phone);
  },

  /**
   * 判断邮箱
   * 
   * @params email 要判断的字符串
   */
  isEmail(email) {
    return /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(email);
  },

  /**
   * 替换空字符串
   
   * @param str 字符串
   */
  trim(str) {
    str = str.replace(/(^\s*)|(\s*$)/g, "");
    return str
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/tool.js